// Dua area terpisah (Dokumen Teknis §3.2/§13.1): portal publik (tanpa login)
// & panel internal (SPA, RBAC per rute).
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import type { RoleName } from '@/stores/auth'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'internal-login', query: { redirect: to.fullPath } }
  }
  const roles = to.meta.roles as RoleName[] | undefined
  if (roles && !auth.hasRole(...roles)) {
    return { name: 'internal-dashboard' }
  }
  return true
})

export default router
